(() => {
if (window.__lpfLoaded) return;
window.__lpfLoaded = true;
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
function initRail(scope) {
const rail = $('[data-lpf-rail]', scope);
if (!rail || rail.__lpf) return;
rail.__lpf = true;
const prev = $('[data-lpf-prev]', scope);
const next = $('[data-lpf-next]', scope);
const bar = $('.lpf-progress__bar', scope);
const step = () => (rail.children[0] ? rail.children[0].getBoundingClientRect().width + 20 : rail.clientWidth);
const update = () => {
const max = rail.scrollWidth - rail.clientWidth;
if (prev) prev.disabled = rail.scrollLeft <= 4;
if (next) next.disabled = rail.scrollLeft >= max - 4;
if (bar) {
const ratio = rail.clientWidth / rail.scrollWidth;
bar.style.width = ratio * 100 + '%';
bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * (1 / ratio - 1) * 100 : 0) + '%)';
bar.parentElement.hidden = ratio >= 0.999;
}
};
if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
rail.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', update);
update();
}
function initAutoSwipe(container) {
if (!container || container.__lpfAuto) return;
if (!window.matchMedia('(max-width: 699px)').matches) return;
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
container.__lpfAuto = true;
const interval = parseInt(container.dataset.lpfAutoswipe, 10) || 4200;
let timer = 0;
let paused = false;
let pauseTimer = 0;
const tick = () => {
if (paused || document.hidden) return;
const max = container.scrollWidth - container.clientWidth;
if (max <= 4) return;
const atEnd = container.scrollLeft >= max - 4;
container.scrollTo({ left: atEnd ? 0 : Math.min(max, container.scrollLeft + container.clientWidth), behavior: 'smooth' });
};
const start = () => { clearInterval(timer); timer = setInterval(tick, interval); };
const stop = () => clearInterval(timer);
const pauseFor = (ms) => {
paused = true;
clearTimeout(pauseTimer);
pauseTimer = setTimeout(() => { paused = false; }, ms);
};
['touchstart', 'pointerdown', 'wheel'].forEach((ev) => container.addEventListener(ev, () => pauseFor(7000), { passive: true }));
document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
if ('IntersectionObserver' in window) {
new IntersectionObserver(([e]) => { if (e.isIntersecting) start(); else stop(); }, { threshold: 0.4 }).observe(container);
} else {
start();
}
}
function initTabs(scope) {
const tabs = $$('[role="tab"]', scope);
if (!tabs.length || scope.__lpf) return;
scope.__lpf = true;
const select = (tab) => tabs.forEach((t) => {
const on = t === tab;
t.setAttribute('aria-selected', String(on));
t.tabIndex = on ? 0 : -1;
const panel = document.getElementById(t.getAttribute('aria-controls'));
if (panel) panel.hidden = !on;
});
tabs.forEach((t) => t.addEventListener('click', () => select(t)));
}
function initLooks(scope) {
const slides = $$('.lpf-look__slide', scope);
if (slides.length < 2 || scope.__lpf) return;
scope.__lpf = true;
let i = 0;
scope.addEventListener('click', (e) => {
const dir = e.target.closest('[data-lpf-look-next]') ? 1 : e.target.closest('[data-lpf-look-prev]') ? -1 : 0;
if (!dir) return;
i = (i + dir + slides.length) % slides.length;
slides.forEach((s, k) => { s.hidden = k !== i; });
});
}
function easter(y) {
const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
n = h + l - 7 * m + 114;
return new Date(y, Math.floor(n / 31) - 1, (n % 31) + 1);
}
function holidays(y) {
const e = easter(y);
const off = (n) => new Date(e.getFullYear(), e.getMonth(), e.getDate() + n);
return [new Date(y, 0, 1), off(1), new Date(y, 4, 1), new Date(y, 4, 8), off(39), off(50), new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25)].map((d) => d.toDateString());
}
function addBusinessDays(n) {
const d = new Date();
const hol = new Set(holidays(d.getFullYear()).concat(holidays(d.getFullYear() + 1)));
while (n > 0) {
d.setDate(d.getDate() + 1);
if (d.getDay() !== 0 && d.getDay() !== 6 && !hol.has(d.toDateString())) n--;
}
return d;
}
function initEta(el) {
if (el.__lpf) return;
el.__lpf = true;
const stock = {};
(el.dataset.stock || '').split(',').forEach((pair) => {
const [id, q] = pair.split(':');
if (id) stock[id.trim()] = parseInt(q, 10);
});
const cur = el.dataset.currency || 'EUR';
const cart = parseInt(el.dataset.cart || '0', 10) || 0;
const fmt = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
const render = (vid, price, available) => {
const q = vid in stock ? stock[vid] : 999;
const inStock = available !== false && q > 0;
const s = $('[data-lpf-stock]', el);
if (s) {
s.textContent = inStock ? (q <= 3 ? 'En stock · plus que ' + q : 'En stock') : 'Sur commande';
s.classList.toggle('is-out', !inStock);
}
$('.lpf-eta__txt', el).innerHTML = 'Livraison estimée entre le <strong>' + fmt(addBusinessDays(5)) + '</strong> et le <strong>' + fmt(addBusinessDays(7)) + '</strong>';
const sh = $('[data-lpf-ship]', el);
if (sh) {
const miss = 3500 - cart - (parseInt(price, 10) || 0);
sh.textContent = miss > 0 ? 'Plus que ' + money(miss, cur) + ' pour la livraison offerte' : 'Livraison offerte';
}
};
render(el.dataset.variant, el.dataset.price);
document.addEventListener('variant:change', (e) => {
const v = e.detail && e.detail.variant;
if (!v || !(String(v.id) in stock)) return;
render(String(v.id), v.price, v.available);
});
}
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const money = (cents, cur) => {
try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur || 'EUR' }); }
catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
};
function mainVariantId() {
const forms = $$('form[is="product-form"]').filter((f) => !f.closest('.lpf'));
for (const f of forms) {
const el = (f.id && document.querySelector('[name="id"][form="' + f.id + '"]')) || f.querySelector('[name="id"]');
if (el && el.value) return el.value;
}
return null;
}
async function addToCart(variantId) {
const res = await fetch(ROOT + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
});
const json = await res.json();
if (!res.ok) throw new Error(json.description || json.message || 'Ajout impossible');
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
const drawer = document.getElementById('cart-drawer');
if (drawer && typeof drawer.show === 'function') drawer.show();
else window.location.href = ROOT + 'cart';
return json;
}
function initQuickVariant(scope) {
$$('[data-lpf-qv-open]', scope).forEach((btn) => {
if (btn.__lpf) return;
btn.__lpf = true;
const host = btn.parentElement;
const dialog = host && host.querySelector('dialog.lpf-qv');
if (!dialog) return;
btn.addEventListener('click', () => {
if (typeof dialog.showModal === 'function') dialog.showModal();
});
const close = () => { if (dialog.open) dialog.close(); };
const closeBtn = $('[data-lpf-qv-close]', dialog);
if (closeBtn) closeBtn.addEventListener('click', close);
dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
const err = $('[data-lpf-qv-err]', dialog);
$$('[data-lpf-qv-variant]', dialog).forEach((opt) => {
opt.addEventListener('click', async () => {
if (opt.disabled || opt.getAttribute('aria-busy') === 'true') return;
opt.setAttribute('aria-busy', 'true');
if (err) err.hidden = true;
try {
await addToCart(opt.dataset.lpfQvVariant);
close();
} catch (x) {
if (err) { err.textContent = x.message || 'Ajout impossible, réessayez.'; err.hidden = false; }
} finally {
opt.removeAttribute('aria-busy');
}
});
});
});
}
function initMulti(form) {
if (form.__lpf) return;
form.__lpf = true;
const cur = form.dataset.currency || 'EUR';
const free = parseInt(form.dataset.free || '0', 10);
const rows = $$('[data-lpf-item]', form);
const cta = $('[data-lpf-cta]', form);
const err = $('[data-lpf-err]', form);
const main = $('[data-lpf-main]', form);
const isOn = (r) => { const cb = $('input[type="checkbox"]', r); return !cb || cb.checked; };
const update = () => {
let total = 0, n = 0;
rows.forEach((r) => {
r.classList.toggle('is-off', !isOn(r));
if (isOn(r)) { total += parseInt(r.dataset.price, 10) || 0; n++; }
});
$('[data-lpf-total]', form).textContent = money(total, cur);
const ship = $('[data-lpf-ship]', form);
if (ship && free) ship.textContent = total >= free ? 'Livraison offerte' : 'Plus que ' + money(free - total, cur) + ' pour la livraison offerte';
cta.textContent = n > 1 ? 'Ajouter les ' + n + ' au panier' : 'Ajouter au panier';
cta.disabled = n === 0;
};
form.addEventListener('change', (e) => {
const sel = e.target.closest('[data-lpf-sel]');
if (sel) {
const row = sel.closest('[data-lpf-item]');
const opt = sel.options[sel.selectedIndex];
$('[data-lpf-vid]', row).value = sel.value;
row.dataset.price = opt.dataset.price;
$('[data-lpf-price]', row).textContent = money(parseInt(opt.dataset.price, 10), cur);
}
update();
});
if (main) {
const ids = (main.dataset.ids || '').split(',');
document.addEventListener('variant:change', (e) => {
const v = e.detail && e.detail.variant;
if (!v || ids.indexOf(String(v.id)) === -1) return;
$('[data-lpf-vid]', main).value = v.id;
main.dataset.price = v.price;
$('[data-lpf-price]', main).textContent = money(v.price, cur);
update();
});
}
form.addEventListener('submit', async (e) => {
e.preventDefault();
if (main) { const id = mainVariantId(); if (id) $('[data-lpf-vid]', main).value = id; }
const items = rows.filter(isOn).map((r) => ({ id: parseInt($('[data-lpf-vid]', r).value, 10), quantity: 1 }));
if (!items.length) return;
cta.setAttribute('aria-busy', 'true');
err.hidden = true;
try {
const res = await fetch(ROOT + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ items }),
});
const json = await res.json();
if (!res.ok) throw new Error(json.description || json.message || 'Ajout impossible');
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
const drawer = document.getElementById('cart-drawer');
if (drawer && typeof drawer.show === 'function') drawer.show();
else window.location.href = ROOT + 'cart';
} catch (x) {
err.textContent = x.message || 'Ajout impossible, réessayez.';
err.hidden = false;
} finally {
cta.removeAttribute('aria-busy');
}
});
update();
}
function initClamp(root) {
if (!window.matchMedia('(max-width: 699px)').matches) return;
$$('.shopify-section--multiple-images-with-text .prose', root).forEach((el) => {
if (el.__lpf || el.scrollHeight < 420) return;
el.__lpf = true;
const wrap = document.createElement('div');
wrap.className = 'lpf-clamp';
while (el.firstChild) wrap.appendChild(el.firstChild);
el.appendChild(wrap);
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'lpf-clamp__btn';
btn.textContent = 'Lire la suite';
btn.setAttribute('aria-expanded', 'false');
btn.addEventListener('click', () => {
const open = wrap.classList.toggle('is-open');
btn.textContent = open ? 'Réduire' : 'Lire la suite';
btn.setAttribute('aria-expanded', String(open));
});
el.appendChild(btn);
});
}
function initSticky(bar) {
if (bar.__lpf) return;
if (window.__lpfSticky) { bar.remove(); return; }
const getMain = () => $('.shopify-section--main-product .product-info__buy-buttons button[type="submit"]');
if (!getMain()) { bar.remove(); return; }
bar.__lpf = true;
window.__lpfSticky = bar;
document.body.appendChild(bar);
bar.hidden = false;
const btn = $('[data-lpf-sticky-btn]', bar);
const priceEl = $('[data-lpf-sticky-price]', bar);
const fmt = bar.dataset.moneyFormat || '';
const fmtMoney = (cents) => {
const n = cents / 100;
const comma = n.toFixed(2).replace('.', ',');
if (!fmt) return comma + ' €';
return fmt
.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(n)))
.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
.replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2))
.replace(/\{\{[^}]*\}\}/, comma);
};
const foot = $('.shopify-section--footer');
let ticking = false;
const sync = () => {
ticking = false;
const vh = window.innerHeight;
const m = getMain();
let show = false;
if (m) {
const r = m.getBoundingClientRect();
show = r.bottom < 0 || r.top > vh - 8;
}
if (show && foot && foot.getBoundingClientRect().top < vh) show = false;
bar.classList.toggle('is-visible', show);
document.body.classList.toggle('lpf-has-sticky', show);
};
const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };
window.addEventListener('scroll', req, { passive: true });
window.addEventListener('resize', req);
sync();
btn.addEventListener('click', () => {
const m = getMain();
if (!m || btn.disabled || m.disabled) return;
m.click();
});
document.addEventListener('variant:change', (e) => {
const v = e.detail && e.detail.variant;
if (!v) { btn.disabled = true; btn.textContent = 'Indisponible'; return; }
if (priceEl && typeof v.price === 'number') priceEl.textContent = fmtMoney(v.price);
btn.disabled = !v.available;
btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
req();
});
}
function initPager(scope) {
if (scope.__lpf) return;
scope.__lpf = true;
const track = $('[data-lpf-autoswipe]', scope);
if (!track) return;
const prev = $('[data-lpf-pager-prev]', scope);
const next = $('[data-lpf-pager-next]', scope);
const dotsWrap = $('[data-lpf-pager-dots]', scope);
const dots = dotsWrap ? $$('.lpf-dot', dotsWrap) : [];
const currentIndex = () => {
const w = track.clientWidth || 1;
const n = dots.length || 1;
return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
};
const go = (dir) => {
const n = dots.length || Math.max(1, Math.round(track.scrollWidth / (track.clientWidth || 1)));
const idx = (currentIndex() + dir + n) % n;
track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
track.dispatchEvent(new Event('pointerdown'));
};
if (prev) prev.addEventListener('click', () => go(-1));
if (next) next.addEventListener('click', () => go(1));
if (dots.length) {
const sync = () => {
const idx = currentIndex();
dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
};
track.addEventListener('scroll', sync, { passive: true });
window.addEventListener('resize', sync);
sync();
}
}
function init(root) {
$$('[data-lpf-multi]', root).forEach(initMulti);
$$('[data-lpf-carousel]', root).forEach(initRail);
$$('[data-lpf-tabs-scope]', root).forEach(initTabs);
$$('[data-lpf-looks]', root).forEach(initLooks);
$$('[data-lpf-eta]', root).forEach(initEta);
$$('[data-lpf-sticky]', root).forEach(initSticky);
$$('[data-lpf-autoswipe]', root).forEach(initAutoSwipe);
$$('[data-lpf-pager-scope]', root).forEach(initPager);
initQuickVariant(root);
initClamp(root);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
else init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
})();